/**
 * ClassParkingDayPartTimeline — таймлайн слоя «Классифицированные парковки
 * (по времени суток)» (DA-14953).
 *
 * Аналог ClassParkingDayPartRebalancedTimeline, но для слоя по поездкам (не по
 * ребалансу). Заменяет сайдбарную радио-группу «Время суток». Курсор на рельсе
 * выбирает часть дня (5 неравных интервалов, значения 1–5, пресет
 * DAY_PART_CLASS_DOMAIN). Значение пишется в redux
 * (mapFilters.classifiedParkingDayPartStatuses); перезапрос тайлов — в
 * Map.setParkingClassDayPartFilters.
 *
 * Даты/степпера нет: слой агрегирует за 14 дней, выбор — только часть суток.
 * Монтируется только когда слой активен (withDisplayedLayersCheck).
 */
import React from 'react';
import { connect } from 'react-redux';
import { t } from '@lingui/macro';
import { onChangeMapFilters } from '../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../HOC/withDisplayedLayersCheck';
import { MapTimeline } from './MapTimeline';
import { DAY_PART_CLASS_DOMAIN, dayPartClassBands } from './presets';

const ClassParkingDayPartTimelineComponent = ({
    classifiedParkingDayPartStatuses,
    setDayPart,
}) => (
    <MapTimeline
        domain={DAY_PART_CLASS_DOMAIN}
        cursor={classifiedParkingDayPartStatuses ?? 1}
        onCursorChange={value => {
            if (value !== classifiedParkingDayPartStatuses) setDayPart(value);
        }}
        minorTicks
        topBands={dayPartClassBands()}
    />
);
const mapStateToProps = ({ mapFilters: { classifiedParkingDayPartStatuses } }) => ({
    classifiedParkingDayPartStatuses,
});
const mapDispatchToProps = dispatch => ({
    setDayPart: value => dispatch(onChangeMapFilters('classifiedParkingDayPartStatuses', value)),
});
const ConnectedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(ClassParkingDayPartTimelineComponent);

export const ClassParkingDayPartTimeline = withDisplayedLayersCheck(
    ConnectedComponent,
    `${t`Классифицированные парковки`} (${t`по времени суток`})`
);
